// @flow
import {endpoints} from '../../../endpoints'

export const fetchPartnerServiceProviders = async (apiIndex: ApiIndex<MapApi>, fromLocation: string, distance: number = 12000, pageSize: number = 50): Promise<ServiceProvider[]> => {
  
  const params = `partner=${endpoints.partner}&from_location=${fromLocation}&distance_in_m=${distance}&page_size=${pageSize}`
  const apiPath = apiIndex.apis['partner']['service-providers']['list']['url']
  const url = `${apiIndex.basePath}${apiPath}?${params}`
  const response = await fetch(url, {
    headers: {
      'content-type': 'application/json; version=2.0',
      'Accept': 'application/json; version=2.0',
    },
  })

  if (response.status === 200) {
    const result = await response.json()
    return result.results.map(s => s._embedded.service_provider) 
  } else {
    throw new Error(await response.text())
  }
}